import React from 'react';

import {CrewVBucksContainer, VBucksImage} from './components';

interface Props {
  vbucksImage: string;
  vbucksAlt: string;
  battleStarLogo: string;
  battleStarAlt: string;
}

const CrewVBucksImage = ({vbucksImage, vbucksAlt, battleStarLogo, battleStarAlt}: Props) => {
  return (
    <CrewVBucksContainer>
      {battleStarLogo && <VBucksImage src={battleStarLogo} alt={battleStarAlt} />}
      {vbucksImage && <VBucksImage src={vbucksImage} alt={vbucksAlt} />}
    </CrewVBucksContainer>
  );
};

export default CrewVBucksImage;
